<template>
    <div class="view view__licence_list">
        <licence-list/>
    </div>
</template>

<script>
import licenceList from '@/components/ebs/licences/list/LicenceList'

export default {
  components: { licenceList },
  name: 'view-licence-list'
}
</script>
